<template>
  <div class="pc-university">
    <!-- 院校头部面包屑部分 -->
      <BreadCrumb :data="breadcrumb" :title="'院校列表管理'" />

    <!-- 院校排行头部内容部分 -->
    <div class="pc-universityRink-content">
      <!-- 院校排行标题内容 -->
      <div class="pc-ununiversityRink-content-title">
        <!-- 选择时间线 -->
        <div class="time-line">
          <h4>年份</h4>
          <el-select
            v-model="nowYear"
            @change="findYear"
            placeholder="标签"
            class="tag"
          >
            <el-option
              v-for="(item, index) in choiceYearList"
              :key="index"
              :label="item.title"
              :value="item.title"
            ></el-option>
          </el-select>
          <el-radio-group v-model="tabPosition" @change="choiceQuarter">
            <el-radio-button
              v-for="(item, index) in yearBannerList"
              :key="index"
              :label="index"
              >{{ item.subTitle }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <!-- 添加；操作按钮 -->
        <div class="rinkBtn" @click="addUniversity">添加</div>
      </div>
      <!-- 院校排行信息内容 -->
      <div class="pc-universityRink-content-world">
        <div class="universityRink-icon-world">
          <div class="universityRink-icon">
            <i class="el-icon-s-custom"></i>
          </div>
          <!-- 文字显示 -->
          <div class="universityRink-world">
            <span>{{ universityTotal }}</span>
            <h6>院校入库</h6>
          </div>
        </div>
        <!-- 上传图片 -->
        <div class="universityRink-banner-btn">
          <!-- <img :src="choiceArg.image" /> -->
          <div class="rinking-banner-null">
            <el-upload
              class="logoImg"
              :action="uploadUrl"
              list-type="picture-card"
              accept=".png,.PNG,.jpg,.JPG,.jpeg"
              :http-request="uploadRinkingBnner"
              :show-file-list="false"
              :auto-upload="true"
            >
              <img
                v-if="choiceArg.image"
                :src="choiceArg.image"
                class="upload-image"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="process" v-if="coverImageFile != 0">
            <el-progress
              type="circle"
              :width="100"
              :percentage="coverImageFile"
            ></el-progress>
          </div>
          <div class="universityRink-btn">
            上传
            <el-upload
              class="logoImg"
              :action="uploadUrl"
              list-type="picture-card"
              accept=".png,.PNG,.jpg,.JPG,.jpeg"
              :http-request="uploadRinkingBnner"
              :show-file-list="false"
              :auto-upload="true"
            >
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <DialogAdd
      :dialogAdd="dialogAdd"
      @cancelTag="cancelTag"
      @checkTag="checkTag"
    />
    <!-- 院校排行表格部分 -->
    <!-- <div class="pc-universityRink-table"> -->
    <RinkingUniversityTable :nowYear="nowYear" :tabPosition="tabPosition" ref="rinkTable" />
    <!-- </div> -->
  </div>
</template>
<script>
import BreadCrumb from "../../componentSet/BreadCrumb";

import RinkingUniversityTable from "./components/RinkingUniversityTable";
import DialogAdd from "./components/DialogAdd";
// import { getUniversityRanks } from "./universityList.gql";
import {getUniversityRanks, getBanners, addBanner, updateBanner } from "./components/rinkingUniversity.gql";
export default {
  components: {
    BreadCrumb,
    RinkingUniversityTable,
    DialogAdd,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "院校管理", link: "/" },
        { name: "院校排行榜", link: "" },
      ];
    },
  },
  watch: {
    nowSeason(newName, oldName) {
      // this.fullName = newName + ' ' + this.lastName;
      if (newName == "03" || "04" || "05") {
        this.tabPosition = 1;
      } else if (newName == "06" || "07" || "08") {
        this.tabPosition = 2;
      } else if (newName == "09" || "10" || "11") {
        this.tabPosition =3;
      } else if (newName == "12" || "01" || "02") {
        this.tabPosition = 4;
      }
    },
  },
  data() {
    return {
      // 年份数组
      // yearList:[],
      // 院校total
      universityTotal: 0,
      //  新增弹框
      dialogAdd: false,
      // 选择年份
      nowYear: "",
      nowSeason: "",
      seasonList:['spring','summer','autumn','winter'],
      yearList: [
        {
          title: "2012",
          subTitle: "summer",
          position: "",
          image: "",
          orderNum: "",
        },
      ],
      yearBannerList: [],
      choiceYearList: [],
      // 初始显示的面板
      tabPosition: 0,
      rinkingBanner: "",
      // 上传图片初始URL
      uploadUrl: "",
      dataArgs: {
        take: 1,
        status: -1,
        year:''
      },
      bannerArgs: {
        position: "yearQuarter",
      },
      coverImageFile: 0,
      // 当前选中的数组
      choiceArg: {
        id: "",
        image: "",
      },
      // nowYear:'',
    };
  },
  created() {},
  mounted() {
    this.year();
    this.getBanners();
  },
  methods: {
    // 计算今年年份
    year() {
      this.nowSeason = this.$dtime(new Date()).format("MM");
      this.nowYear = this.$dtime(new Date()).format("YYYY");
    },
    // 重拍数组
    rearrangement(yearBannerList){
      let nullSeason=[]
      for(let i=0;yearBannerList.length>i;i++){
        if('spring'==yearBannerList[i].subTitle){
           nullSeason[0]=yearBannerList[i]
        }else if(yearBannerList[i].subTitle=='summer'){
          nullSeason[1]=yearBannerList[i]
        }else if(yearBannerList[i].subTitle=='autumn'){
          nullSeason[2]=yearBannerList[i]
        }else if(yearBannerList[i].subTitle=='winter'){
          nullSeason[3]=yearBannerList[i]
        }  
      }
      this.yearBannerList=nullSeason
          for (let s = 0; yearBannerList.length > s; s++) {
            if ((this.tabPosition+1) == this.yearBannerList[s].orderNum) {
              this.choiceArg.image = this.yearBannerList[s].image;
            }
          }
    },
    getBanners() {
      this.yearBannerList = [];
      this.$global
        .GraphqlQuery(this, getBanners, this.bannerArgs)
        .then((res) => {
          this.yearList = res.data;
          let save = {};
          this.choiceYearList = this.yearList.reduce((cur, next) => {
            save[next.title] ? "" : (save[next.title] = true && cur.push(next));
            return cur;
          }, []); //设置cur默认类型为数组，并且初始值为空的数组
          for (let i = 0; this.yearList.length > i; i++) {
            if (this.nowYear == this.yearList[i].title) {
              this.yearBannerList.push(this.yearList[i]);
            }
          }
          this.rearrangement(this.yearBannerList)
    
          this.getUniversityRanks();
          // choiceArg.image
        });
    },
    getUniversityRanks() {
      this.dataArgs.year=this.nowYear
      this.dataArgs.month=(this.tabPosition+1).toString()
      this.$global
        .GraphqlQuery(this, getUniversityRanks, this.dataArgs)
        .then((res) => {
          this.universityTotal = res.total;
        });
    },
    // 上传头像
    async uploadRinkingBnner(params) {
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.coverImageFile = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.$set(this.choiceArg, "image", res.url.split("?")[0]);
        this.coverImageFile = 0;
        this.updateBanner();
      });
    },
    //  新增学校
    addUniversity() {
      this.dialogAdd = true;
    },
    // 修改banner
    updateBanner() {
      let data = { image: this.choiceArg.image, status: 1 };
      this.$global
        .GraphqlMutation(this, updateBanner, {
          // Parameters
          data: this.$global.checkNull(data),
          id: this.choiceArg.id,
        })
        .then((res) => {
          this.$global.success(this, "操作成功");

          this.getBanners();
        });
    },
    //
    findYear(year) {
      // this.dataArgs.year=year
      this.tabPosition=0
      this.getUniversityRanks()
      this.$refs.rinkTable.changeDataArgs(year)
      this.$refs.rinkTable.changeMonthArgs(1)
      this.getBanners()
    },
    choiceQuarter(index) {
          this.choiceArg.image = this.yearBannerList[index].image;
      this.choiceArg.id = this.yearBannerList[index].id;
  
      this.$refs.rinkTable.changeMonthArgs(this.yearBannerList[index].orderNum)
      this.getUniversityRanks()
      //  this.getBanners()
    },
    cancelTag() {
      this.dialogAdd = false;
    },
    checkTag(form) {
      let { title, subTitle, position, image, links, orderNum, status } = form;
      const subEntity = {
        title,
        subTitle,
        position,
        image,
        links,
        orderNum,
        status,
      };
      this.$global
        .GraphqlMutation(this, addBanner, {
          // Parameters
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.$global.success(this, "操作成功");
          this.dialogAdd=false
          this.getBanners();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-university {
  // 院校头部面包屑部分
  .pc-university-bread {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid $border-color;
    > h2 {
      font-size: 20px;
      padding: 35px 40px 0 0;
      align-self: flex-end;
    }
  }
  // 内容部分
  .pc-universityRink-content {
    margin-top: 40px;
    height: 100%;
    box-shadow: $boxshadow;
    padding: 35px 30px 40px;
    .pc-ununiversityRink-content-title {
      // width: 360px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $indexHotLine;
      padding-bottom: 30px;
      .time-line {
        display: flex;
        h4 {
          align-self: center;
          margin-right: 10px;
          font-size: 14px;
        }
        .el-select {
          margin-right: 40px;
          align-self: center;
        }
        .el-radio-group {
          background: $backGray;
          align-self: center;
          .el-radio-button {
            padding: 2px;
            /deep/ .el-radio-button__inner {
              color: $timeWorld;
              background: $backGray;
              border: none;
            }
            /deep/ .el-radio-button__inner:hover {
              color: $timeWorld;
            }
          }
          // 点击被选中时的样式
          /deep/ .is-active {
            .el-radio-button__inner {
              color: $blueBtna;
              background-color: $base-color;
              border-color: $backGray;

              box-shadow: -1px 0 0 0 $backGray;
            }
          }
        }
      }
      .rinkBtn {
        background: $blueBtna;
        color: $base-color;
        padding: 10px 29px 14px;
        align-self: center;
        border-radius: 4px;
        font-weight: 400;
        font-family: $english;
      }
    }
    .pc-universityRink-content-world {
      margin-top: 40px;
      display: flex;
      justify-content: space-around;
      .universityRink-icon-world {
        display: flex;
        .universityRink-icon {
          width: 100px;
          height: 100px;
          background: $blueBtna;
          display: flex;
          align-self: center;
          justify-content: center;
          border-radius: 50px;
          .el-icon-s-custom {
            font-size: 64px;
            align-self: center;
            color: $base-color;
          }
        }

        .universityRink-world {
          margin-left: 20px;
          align-self: center;
          span {
            font-size: 60px;
            color: $blueBtna;
          }
          h6 {
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
      .universityRink-banner-btn {
        display: flex;
        width: 70%;
        .rinking-banner-null {
          width: 70%;
          .logoImg {
            .el-upload--picture-card{
              width: 1000px;
              height: 150px;
              img{
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
          }
          /deep/ .el-upload {
            width: 100%;
          }
        }
        .universityRink-btn {
          position: relative;
          margin-left: 20px;
          background: #5470c6;
          color: #fff;
          padding: 10px 29px 14px;
          -ms-flex-item-align: center;
          align-self: center;
          border-radius: 4px;
          font-weight: 400;
          font-family: "PingFangSC-Regular", "PingFang SC";
          cursor: pointer;
          .logoImg {
            position: absolute;
            top: 0;
            left: 0;
            /deep/ .el-upload--picture-card {
              width: 90px;
              height: 45px;
              opacity: 0;
            }
          }
        }
      }
    }
  }
  .pc-universityRink-table {
    margin-top: 40px;
    height: 100%;
    box-shadow: $boxshadow;
    padding: 35px 30px;
    margin-right: 40px;
  }
  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .el-table__body-wrapper {
      min-height: 713px;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
    }
    /deep/ .is-leaf {
      border-top:1px solid #EBEEF5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/university/RinkingUniversity.vue